import { createContext, useEffect, useState } from "react";
import Router from "./routes";
import ThemeProvider from "./theme";
import "./App.css";
import { Provider } from "react-redux";
import store from "./store/store";

export const Data = createContext();
export const EmailData = createContext();

function App() {
  return (
    <ThemeProvider>
      <Provider store={store}>
        <Router />
      </Provider>
    </ThemeProvider>
  );
}
export default App;

